import { render, staticRenderFns } from "./verticalSlider.vue?vue&type=template&id=36367540&scoped=true&"
import script from "./verticalSlider.vue?vue&type=script&lang=js&"
export * from "./verticalSlider.vue?vue&type=script&lang=js&"
import style0 from "./verticalSlider.vue?vue&type=style&index=0&id=36367540&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36367540",
  null
  
)

export default component.exports